import '../stylesheets/LinksPage.css';

export function LinksPage() {
    return (
        <div className='LinksPage'>
            <ul>
                <li>
                    Ամսաթերթի անգլերեն տարբերակը - &nbsp;
                    <a
                        href='./journals/tert-english-12-2022.pdf'
                        rel='noopener noreferrer'
                        target='_blank'
                    >
                        Համար 1
                    </a>
                </li>

                <li>
                    Ամսագրի հին համարներում հայերեն տեքստերը գրված են ArmScii կոդավորմամբ։
                    <br /> Դրանք փոխարկելու համար կարող եք օգտագործել - &nbsp;
                    <a href='/unicode_converter.html' >
                        Հայերեն Unicode փոխարկիչը
                    </a>
                </li>
                <p>Այլ օգտակար հղումներ </p>
                <li>
                    <a href='http://barilur.org/bible/'
                        rel='noopener noreferrer'
                        target='_blank' >
                        Հայերեն Աստվածաշունչ
                    </a>
                </li>
                <li>
                    <a href='https://ergaran.org'
                        rel='noopener noreferrer'
                        target='_blank' >
                        Հոգեւոր երգարան
                    </a>
                </li>

            </ul>
        </div>
    )
}
